import api from '../api';

export async function errorBoundaryHelper(error: Error, info: { componentStack: string }, trackingID: number, sessionID: number) {
  api.logErrorBoundaryMessage(error.message, trackingID, sessionID);
}
